<template>
  <ProductDetailPageBase>
    <ProductDetailPageLayout>
      <template #header>
        <ContainerSkinnyBanner />
      </template>
      <template #breadcrumb>
        <JPContainerBreadcrumb />
      </template>
      <template #out-of-stock>
        <ContainerOutOfStock />
      </template>
      <template #product-aside-content>
        <JPContainerSeller />
      </template>
    </ProductDetailPageLayout>
  </ProductDetailPageBase>
</template>

<script setup lang="ts">
import ContainerOutOfStock from '~/scopes/product-core/components/ContainerOutOfStock/ContainerOutOfStock.vue'
import ContainerSkinnyBanner from '~/scopes/product-core/components/ContainerSkinnyBanner/ContainerSkinnyBanner.vue'
import ProductDetailPageBase from '~/scopes/product-core/components/ProductDetailPageBase/ProductDetailPageBase.vue'
import ProductDetailPageLayout from '~/scopes/product-core/components/ProductDetailPageLayout/ProductDetailPageLayout.vue'

import JPContainerBreadcrumb from './components/JPContainerBreadcrumb/JPContainerBreadcrumb.vue'
import JPContainerSeller from './components/JPContainerSeller/JPContainerSeller.vue'
</script>
